import IWallMetaData from 'components/interfaces/IWallMetaData';

import { SET_WALL_META_DATA, SET_WALLS_META_DATA } from './types';

export const setWallMetaData = (
  wallMetaData: IWallMetaData
): {
  wallMetaData: IWallMetaData;
  type: string;
} => ({
  wallMetaData,
  type: SET_WALL_META_DATA,
});

export const setWallsMetaData = (
  wallsMetaData: IWallMetaData[]
): {
  wallsMetaData: IWallMetaData[];
  type: string;
} => ({
  wallsMetaData,
  type: SET_WALLS_META_DATA,
});
